/*
 *
 * TtlCountdown
 *
 * @version 1.0.0
 * @author Magarelli_Fabrizio
 * @since 01-Oct-2024
 */

import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import Toggle from 'Hoc/ToggleComponent'
import formattedMessage, { ariaLabels } from './languageModule'
import './TtlCountdown.scss'

const TtlCountdown = ({ intl }) => {
  const [timeLeft, setTimeLeft] = useState({ minutes: 0, seconds: 0 })

  const calculateTimeLeft = () => {
    const ttl = JSON.parse(window.sessionStorage.getItem('TTL'))?.TTL
    if (!ttl) return { minutes: 0, seconds: 0 }

    const diffInSeconds = moment(ttl, 'HH:mm:ss').diff(moment(), 'seconds')

    return diffInSeconds > 0
      ? { minutes: Math.floor(diffInSeconds / 60), seconds: diffInSeconds % 60 }
      : { minutes: 0, seconds: 0 }
  }

  const updateTime = () => {
    setTimeLeft(calculateTimeLeft())
  }

  useEffect(() => {
    updateTime()

    const intervalId = setInterval(updateTime, 1000)

    return () => clearInterval(intervalId)
  }, [])

  const { minutes, seconds } = timeLeft
  const isAlmostExpired = minutes === 0 && seconds < 11
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds

  return (
    <Toggle>
      <div className='countdown_container'>
        <p aria-label={intl.formatMessage(ariaLabels.descriptionAriaLabel)}>{formattedMessage.description}</p>
        {minutes === 0 && seconds === 0 ? null : (
          <span
            aria-label={`${intl.formatMessage(ariaLabels.countdownAriaLabel)} ${minutes}:${seconds}`}
            className={`countdown ${isAlmostExpired ? 'red_numbers' : ''}`}>
            {minutes}:{formattedSeconds}
          </span>
        )}
      </div>
    </Toggle>
  )
}

TtlCountdown.propTypes = {
  intl: PropTypes.object
}

TtlCountdown.defaultProps = {
  intl: {}
}

export default injectIntl(TtlCountdown)
